import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import "./AccessibilityWidget.css";

// ─── SVG ICONS (compact sizing) ───────────────────────────────────────────────
const icons = {
  accessibility: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" aria-hidden="true">
      <path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-7.5 5.5a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-4.25v3.1l2.8 8.1a1 1 0 1 1-1.9.66L13.3 13h-2.6l-1.85 5.36a1 1 0 1 1-1.9-.66l2.8-8.1V8.5H5.5a1 1 0 0 1-1-1z" />
    </svg>
  ),
  close: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  ),
  contrast: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16V5c3.86 0 7 3.14 7 7s-3.14 7-7 7z" />
    </svg>
  ),
  desaturate: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M12 3l-4.5 9h9L12 3zm0 3.86L14.08 11H9.92L12 6.86zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5S15.01 22 17.5 22s4.5-2.01 4.5-4.5S19.99 13 17.5 13zM6.5 13C4.01 13 2 15.01 2 17.5S4.01 22 6.5 22s4.5-2.01 4.5-4.5S8.99 13 6.5 13z" />
    </svg>
  ),
  invert: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z" />
    </svg>
  ),
  link: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
    </svg>
  ),
  font: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z" />
    </svg>
  ),
  cursor: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M4 0l16 12.279-6.951 1.17 4.325 8.817-3.596 1.734-4.35-8.879-5.428 4.702z" />
    </svg>
  ),
  focus: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4h4v-2H5v-2zm14 0v2h-2v2h4v-4h-2zm-14-9V4H1v4h2V6h2V5zM19 5h-2V3h-4v2h4v2h2V5zM5 11H3v2h2v-2zm16 0h-2v2h2v-2zM11 19H9v2h6v-2h-4z" />
    </svg>
  ),
  guide: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true">
      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z" />
    </svg>
  ),
  reset: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13" aria-hidden="true">
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
    </svg>
  ),
};

// ─── DEFAULT STATE ─────────────────────────────────────────────────────────────
const defaultSettings = {
  fontSize: 100,
  highContrast: false,
  desaturate: false,
  invertColors: false,
  highlightLinks: false,
  readableFont: false,
  bigCursor: false,
  focusHighlight: false,
  readingGuide: false,
};

const STORAGE_KEY = "ob_accessibility_settings";
const PORTAL_ID = "ob-a11y-portal";

const ensurePortal = () => {
  let portal = document.getElementById(PORTAL_ID);
  if (!portal) {
    portal = document.createElement("div");
    portal.id = PORTAL_ID;
    document.body.appendChild(portal);
  }
  return portal;
};

// ─── BUILD filter string applied to <html> ────────────────────────────────────
const buildFilter = (s) => {
  const parts = [];
  if (s.highContrast) parts.push("contrast(1.6)");
  if (s.desaturate) parts.push("grayscale(1)");
  if (s.invertColors) parts.push("invert(1) hue-rotate(180deg)");
  return parts.join(" ") || "none";
};

// ─── BUILD the REVERSE filter for the portal (so widget stays normal) ─────────
const buildReverseFilter = (s) => {
  const parts = [];
  if (s.invertColors) parts.push("invert(1) hue-rotate(180deg)");
  if (s.desaturate) parts.push("saturate(9999)");
  if (s.highContrast) parts.push("contrast(0.625)");
  return parts.join(" ") || "none";
};

// ─── READING GUIDE ────────────────────────────────────────────────────────────
let readingGuideEl = null;
const ensureReadingGuide = () => {
  if (!readingGuideEl) {
    readingGuideEl = document.createElement("div");
    readingGuideEl.id = "ob-reading-guide";
    const portal = document.getElementById(PORTAL_ID);
    (portal || document.body).appendChild(readingGuideEl);
  }
};
const removeReadingGuide = () => {
  if (readingGuideEl) {
    readingGuideEl.remove();
    readingGuideEl = null;
  }
};

// ─── COMPONENT ────────────────────────────────────────────────────────────────
const AccessibilityWidget = () => {
  const [open, setOpen] = useState(false);
  const [portalEl, setPortalEl] = useState(null);
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? { ...defaultSettings, ...JSON.parse(saved) } : defaultSettings;
    } catch {
      return defaultSettings;
    }
  });

  const panelRef = useRef(null);
  const triggerRef = useRef(null);
  const lastToggleAt = useRef(0);

  // Ensure portal exists (covers missing markup / late DOM)
  useEffect(() => {
    setPortalEl(ensurePortal());
  }, []);

  // Persist settings
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }, [settings]);

  // Apply settings
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const portal = document.getElementById(PORTAL_ID);

    html.style.filter = buildFilter(settings);
    if (portal) portal.style.filter = buildReverseFilter(settings);

    html.style.backgroundColor = "";
    body.style.backgroundColor = "";
    html.style.fontSize = `${settings.fontSize}%`;

    body.classList.toggle("ob-highlight-links", settings.highlightLinks);
    body.classList.toggle("ob-readable-font", settings.readableFont);
    body.classList.toggle("ob-big-cursor", settings.bigCursor);
    body.classList.toggle("ob-focus-highlight", settings.focusHighlight);

    if (settings.readingGuide) {
      ensureReadingGuide();
      const moveGuide = (e) => {
        const y = e.touches ? e.touches[0].clientY : e.clientY;
        if (readingGuideEl) readingGuideEl.style.top = `${y - 14}px`;
      };
      window.addEventListener("mousemove", moveGuide, { passive: true });
      window.addEventListener("touchmove", moveGuide, { passive: true });
      return () => {
        window.removeEventListener("mousemove", moveGuide);
        window.removeEventListener("touchmove", moveGuide);
      };
    }
    removeReadingGuide();
  }, [settings]);

  // Lock body scroll while panel open on small screens
  useEffect(() => {
    if (!open) return undefined;
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if (!isMobile) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // Close on outside press — ignore ghost mouse events right after open
  useEffect(() => {
    if (!open) return undefined;
    const openedAt = Date.now();

    const handleOutside = (e) => {
      // Ignore compatibility mouse events that follow a touch open (~300ms)
      if (Date.now() - openedAt < 450) return;
      const target = e.target;
      if (
        panelRef.current &&
        !panelRef.current.contains(target) &&
        triggerRef.current &&
        !triggerRef.current.contains(target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutside);
    return () => document.removeEventListener("pointerdown", handleOutside);
  }, [open]);

  // Close on Escape
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  const toggle = useCallback((key) => {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const setFontSize = useCallback((delta) => {
    setSettings((prev) => ({
      ...prev,
      fontSize: Math.min(150, Math.max(70, prev.fontSize + delta)),
    }));
  }, []);

  const resetAll = useCallback(() => {
    setSettings(defaultSettings);
  }, []);

  const handleTriggerClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const now = Date.now();
    // Debounce ghost click that would immediately re-toggle on mobile
    if (now - lastToggleAt.current < 400) return;
    lastToggleAt.current = now;
    setOpen((v) => !v);
  }, []);

  const ToggleRow = useCallback(
    ({ icon, label, settingKey }) => {
      const active = settings[settingKey];
      return (
        <div
          className={`ob-a11y-row${active ? " ob-a11y-row--active" : ""}`}
          onClick={() => toggle(settingKey)}
          role="switch"
          aria-checked={active}
          aria-label={label}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === " " || e.key === "Enter") {
              e.preventDefault();
              toggle(settingKey);
            }
          }}
        >
          <span className="ob-a11y-row-icon">{icon}</span>
          <span className="ob-a11y-row-label">{label}</span>
          <span
            className={`ob-a11y-toggle${active ? " active" : ""}`}
            aria-hidden="true"
          >
            <span className="ob-a11y-toggle-thumb" />
          </span>
        </div>
      );
    },
    [settings, toggle]
  );

  if (!portalEl) return null;

  return ReactDOM.createPortal(
    <>
      {open && (
        <div
          className="ob-a11y-backdrop"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      <button
        type="button"
        ref={triggerRef}
        className={`ob-a11y-trigger${open ? " ob-a11y-trigger--open" : ""}`}
        onClick={handleTriggerClick}
        aria-label={open ? "Close Accessibility Panel" : "Open Accessibility Panel"}
        aria-expanded={open}
        aria-controls="ob-a11y-panel"
        title="Accessibility"
      >
        <span className="ob-a11y-trigger-ring" />
        {open ? icons.close : icons.accessibility}
      </button>

      <div
        id="ob-a11y-panel"
        ref={panelRef}
        className={`ob-a11y-panel${open ? " open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Accessibility Settings"
        aria-hidden={!open}
      >
        <div className="ob-a11y-header">
          <div className="ob-a11y-header-title">
            <span className="ob-a11y-header-icon">{icons.accessibility}</span>
            <span>Accessibility</span>
          </div>
          <button
            type="button"
            className="ob-a11y-close"
            onClick={() => setOpen(false)}
            aria-label="Close Accessibility Panel"
          >
            {icons.close}
          </button>
        </div>

        <div className="ob-a11y-body">
          <div className="ob-a11y-section-label">TEXT SIZE</div>
          <div className="ob-a11y-font-row">
            <button
              type="button"
              className="ob-a11y-font-btn"
              onClick={() => setFontSize(-10)}
              aria-label="Decrease text size"
              disabled={settings.fontSize <= 70}
            >
              A−
            </button>
            <span className="ob-a11y-font-percent">{settings.fontSize}%</span>
            <button
              type="button"
              className="ob-a11y-font-btn"
              onClick={() => setFontSize(10)}
              aria-label="Increase text size"
              disabled={settings.fontSize >= 150}
            >
              A+
            </button>
            <button
              type="button"
              className="ob-a11y-font-reset"
              onClick={() => setSettings((p) => ({ ...p, fontSize: 100 }))}
              aria-label="Reset text size"
            >
              Reset
            </button>
          </div>

          <div className="ob-a11y-section-label" style={{ marginTop: "14px" }}>
            ADJUSTMENTS
          </div>
          <div className="ob-a11y-rows">
            <ToggleRow icon={icons.contrast} label="High contrast" settingKey="highContrast" />
            <ToggleRow icon={icons.desaturate} label="Desaturate" settingKey="desaturate" />
            <ToggleRow icon={icons.invert} label="Invert colours" settingKey="invertColors" />
            <ToggleRow icon={icons.link} label="Highlight links" settingKey="highlightLinks" />
            <ToggleRow icon={icons.font} label="Readable font" settingKey="readableFont" />
            <ToggleRow icon={icons.cursor} label="Big cursor" settingKey="bigCursor" />
            <ToggleRow icon={icons.focus} label="Focus highlight" settingKey="focusHighlight" />
            <ToggleRow icon={icons.guide} label="Reading guide" settingKey="readingGuide" />
          </div>
        </div>

        <div className="ob-a11y-footer">
          <button type="button" className="ob-a11y-reset-btn" onClick={resetAll}>
            {icons.reset}
            Reset all settings
          </button>
        </div>
      </div>
    </>,
    portalEl
  );
};

export default AccessibilityWidget;
